import { subHours } from 'date-fns';
import { getTimezoneOffset } from 'date-fns-tz';

const verbose = false;

function isLeadTimeExpired(
  requestedCheckIn: Date,
  leadTimeInHours: number,
  brandTimezone: string
): boolean {
  const currentDate = new Date();
  const brandTZOffsetInMS = getTimezoneOffset(brandTimezone, currentDate);
  const brandOffsetInHours = brandTZOffsetInMS / (60 * 60 * 1000);

  const browserTZOffsetInMinutes = currentDate.getTimezoneOffset();
  const browserOffsetInHours = -browserTZOffsetInMinutes / 60;

  const browserBrandDelta = browserOffsetInHours - brandOffsetInHours;
  const dateAtBrand = subHours(currentDate, browserBrandDelta);
  const leadTimeRemaining = requestedCheckIn.getTime() - dateAtBrand.getTime();

  /* c8 ignore next 6 - Debug logging disabled by verbose flag */
  verbose &&
    console.log(
      'lead time remaining',
      leadTimeRemaining,
      leadTimeRemaining / (60 * 60 * 1000)
    );

  const leadTimeInHoursRemaining = leadTimeRemaining / (60 * 60 * 1000);
  const expired = leadTimeInHoursRemaining < leadTimeInHours;
  return expired;
}

export default isLeadTimeExpired;
